<template>
  <div :class="['nebActionButton', type, {'disabled': disabled}]"
    role="button"
    v-neb-click-outside="onClickOutside"
  >
    <div class="nebActionButton-button"
      @click="onDefaultClick"
    >
      <span class="nebActionButton-button-text">
        {{ text }}
      </span>
    </div>

    <div class="nebActionButton-dropdownArrow"
      @click="onDropdownClick"
    >
      <neb-icon name="triangleDown"
        height="8px"
        width="8px"
      ></neb-icon>
    </div>

    <div class="nebActionButton-dropdown"
      v-show="open"
    >
      <div class="nebActionButton-dropdown-option"
        v-for="opt in dropdownOptions"
        :key="opt.value"
        :class="[
          { 'disabled': opt.disabled }
        ]"
        @click="select(opt)"
      >
        <span class="optionLabel">{{ opt.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import NebIcon from '../../Icon'

export default {
  name: 'ActionButton',

  components: {
    NebIcon
  },

  props: {
    text: {
      type: String,
      default: 'Actions'
    },
    type: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dropdownOptions: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    open: false
  }),

  methods: {
    onDefaultClick () {
      if (this.disabled) { return }
      this.$emit('defaultClick')
    },
    onDropdownClick () {
      if (this.disabled) { return }
      this.open = !this.open
    },
    select (opt) {
      if (this.disabled || opt.disabled) { return }
      this.open = false
      this.$emit('select', opt)
    },
    onClickOutside () {
      if (this.open) { this.open = false }
    }
  }
}
</script>

<style lang="scss">
@import '../../style.scss';

.nebActionButton {
  box-sizing: border-box;
  // overflow: hidden;
  display: inline-flex;
  align-items: center;
  border-radius: 3px;
  cursor: pointer;
  position: relative;

  &.primary {
    background-color: $tiffany-blue;
  }

  &.disabled {
    opacity: 50%;
    cursor: not-allowed;
  }

  &-button  {
    box-sizing: border-box;
    overflow: hidden;
    padding: 10px 20px;
    border-right: 1px solid  $white;

    &-text {
      font-family: $defaultFont;
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: $white;
    }
  }

  &-dropdownArrow {
    box-sizing: border-box;
    overflow: hidden;
    padding: 14px 13px;
    border-left: 1px solid $white;
    color: $white;
  }

  &-dropdown {
    background-color: $white;
    border-radius: 3px;
    border: solid 1px $pinkish-grey;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 42px;
    right: 0;
    min-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    box-sizing: border-box;
    max-height: 310px;
    overflow-x: hidden;
    overflow-y: scroll;
    z-index: 2001;
    padding: 5px 0;

    &-option {
      cursor: pointer;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      box-sizing: border-box;
      padding: 9px 15px;

      .optionLabel {
        font-size: 12px;
        font-family: $defaultFont;
        color: $slate-grey;
        white-space: nowrap;
      }

      &:hover {
        &:not(.disabled) {
          background-color: $duck-egg-blue;
        }
      }

      &.disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
    }
  }
}
</style>
